import { isEmpty, mapValues, cloneDeep } from 'lodash';

export const exportData = (dataObject, groupedKeys, isStackedData = false) => {
   let copyOfData = cloneDeep(dataObject);
   let flattenedData = [];

   if (isStackedData) {
      _.map(copyOfData, (eachData, key) => {
         flattenData(flattenedData, eachData, key, groupedKeys);
         flattenedData.push({});
         flattenedData.push({});
      });
   } else {
      flattenData(flattenedData, copyOfData, null, groupedKeys);
   }

   return flattenedData;
};

const flattenData = (
   flattenedData,
   collection,
   key,
   groupedKeys,
   includeThis
) => {
   const first = groupedKeys[0];
   const rest = groupedKeys.slice(1);

   mapValues(collection, (eachValue) => {
      const tempRow = eachValue.subRows;
      delete eachValue.subRows;
      const data = isEmpty(key)
         ? { ...includeThis, ...eachValue }
         : { date: key, ...includeThis, ...eachValue };
      flattenedData.push(data);

      if (tempRow) {
         flattenData(flattenedData, tempRow, key, rest, {
            ...includeThis,
            [first]: eachValue[first],
         });
      }
   });
};
